import { render, staticRenderFns } from "./_PlayerScreenshots.vue?vue&type=template&id=b843fda6&scoped=true&"
import script from "./_PlayerScreenshots.vue?vue&type=script&lang=ts&"
export * from "./_PlayerScreenshots.vue?vue&type=script&lang=ts&"
import style0 from "./_PlayerScreenshots.vue?vue&type=style&index=0&id=b843fda6&scoped=true&lang=css&"
import style1 from "./_PlayerScreenshots.vue?vue&type=style&index=1&id=b843fda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b843fda6",
  null
  
)

export default component.exports